/*
  Die Zahl in der Kiste im Header ausserhalb des Builders.

  DAS PROBLEM (gemeldet 08.09.2026)
  Der Builder schreibt erst beim Klick auf "Zur Kasse" in den Warenkorb.
  Bis dahin liegt die Auswahl nur in localStorage. Auf der Builder-Seite
  zeigt die Kiste diese Auswahl (akSetBuildCount), auf jeder anderen
  Seite rechnet Liquid den Warenkorb.

  Nach "Neu starten" und einer neuen Auswahl standen damit zwei
  verschiedene Zahlen fuer dieselbe Kiste: im Builder die neuen
  Produkte, auf der Startseite der alte Warenkorb. Aus Sicht des
  Benutzers springt die Zahl zurueck.

  DIE REGEL HIER
  Gibt es eine gespeicherte Auswahl und weicht sie vom Warenkorb ab,
  gewinnt die Auswahl. Die Kiste im Header meint "meine Kiste", und die
  ist das, woran gerade gearbeitet wird.

  UND DER LINK MUSS MIT
  Zeigt die Zahl die Auswahl, fuehrt ein Klick in den Builder und nicht
  in den Warenkorb - dort liegen diese Produkte ja noch nicht. Ohne das
  waere die Zahl richtig und das Ziel falsch, und der Benutzer landet
  in einem Warenkorb, der etwas anderes enthaelt als die Zahl daneben
  verspricht.

  Kein Risiko fuer doppelte Positionen: der Builder entfernt beim
  Bestellen zuerst alle eigenen Positionen (_ak_build) aus dem
  Warenkorb und legt die aktuelle Auswahl neu hinein.
*/
(function () {
  'use strict';

  /* Muss mit sections/kiste-builder.liquid uebereinstimmen. */
  var STORE_KEY = 'ak_builder_sel_v1';
  var STORE_TTL = 30 * 24 * 60 * 60 * 1000;
  var BUILDER_URL = '/collections/alle-produkte';

  function storedCount() {
    var raw = null;
    try {
      raw = localStorage.getItem(STORE_KEY);
    } catch (e) {
      return null; /* privater Modus */
    }
    if (!raw) return null;

    var data = null;
    try {
      data = JSON.parse(raw);
    } catch (e) {
      return null;
    }
    if (!data || !data.ids || !data.ids.length) return null;
    if (!data.t || Date.now() - data.t > STORE_TTL) return null;

    return data.ids.length;
  }

  function apply() {
    /* Auf der Builder-Seite nicht eingreifen: dort pflegt render() die
       Zahl bei jedem Klick, und zwar genauer als wir hier koennten. */
    if (document.getElementById('kiste-builder')) return;

    var n = storedCount();
    if (n === null) return;

    var num = document.getElementById('ak-kiste-num');
    if (!num) return;

    var imWarenkorb = parseInt(num.textContent, 10);
    if (imWarenkorb === n) return; /* einig, nichts zu tun */

    if (typeof window.akSetBuildCount === 'function') {
      window.akSetBuildCount(n);
    } else {
      num.textContent = n;
    }

    var link = document.getElementById('cart-icon-bubble');
    if (link) {
      link.setAttribute('href', BUILDER_URL);
      link.setAttribute('title', 'Ihre Auswahl liegt noch im Kistenbauer');
      /* Dawn oeffnet sonst den Warenkorb-Drawer statt dem Link zu folgen. */
      link.removeAttribute('aria-controls');
      link.classList.remove('header__icon--cart');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  /* Zurueck-Button: Seiten aus dem bfcache werden nicht neu aufgebaut,
     DOMContentLoaded feuert dort nicht noch einmal. Genau der Weg, auf
     dem der Fehler aufgefallen ist - vom Builder zurueck. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) apply();
  });
})();
